import { Chip, Divider, Stack, } from '@mui/material';
import React, { useState } from 'react'
import Wares, {All} from './Components/Wares';




const categories = ["Create","Warehouses"];


function Warehouses() {

  const [salestabs, setsalestabs] = useState(<Wares/>)
    const [bcolor, setbColor] = useState([
                "secondary",
                "primary",
                
              ]);
              let resetColor = [
                "primary",
                "primary",
                
              ];
              const handleClick = (n,cat) => {
                let newArray = [...resetColor];
                newArray[n] = "secondary";
                setbColor(newArray);
                switch(cat){
                  case categories[0]:setsalestabs(<Wares/>); break;
                  case categories[1]:setsalestabs(<All/>); break;
                  
                  default:

                }
                
              };  
          return (
            <div>
              {/* remove/ add/ edit user perms */}
              <Stack direction={"column"} mb={2}>
                <Stack direction={"row"}>
                  {categories.map((cat, index) => {
                    return (
                      <Chip
                        sx={{ marginRight: 2 }}
                        label={cat}
                        color={bcolor[index]}
                        onClick={() => handleClick(index,cat)}
                      />
                    );
                  })}
                  
                </Stack>
              </Stack>
              <Divider variant="middle" orientation="horizontal" />
              {salestabs}
                </div>
            )
        }

export default Warehouses